import moment from 'moment';

export default {
  name: 'New Run',
  coronal_model: {
    to_run: true,
    Magnetogram: {
      provider: 'GONG',
      date: moment.utc().format('YYYY-MM-DD'),
      source: moment.utc().format('YYYY-MM-DDTHH:mm:ss'),
      degrees_per_pixel: 1.0,
      gaussian_smoothing_sd: 0.8,
    },
    PFSS: {
      source_surface_radius: 2.6,
      number_of_radial_grid_pts: 128,
      max_degree: 70,
    },
    SCS: {
      start_radius: 2.3,
      end_radius: 0.1,
      number_of_radial_grid_pts: 128,
      max_degree: 70,
    },
    HeliosphereBoundary: {
      degrees_per_pixel: 2.0,
      wind_speed_relation: '240.0+675.0*(1.0+f)**(-0.222)*(1.0-0.8*exp(-(d/0.02)**1.25))**3.0',
      rotate: -10.0,
      speed: {
        add: -50.0,
        max: 625.0,
        min: 275.0,
      },
      fast_solar_wind: {
        magnetic_field: 300.0,
        number_density: 300.0,
      },
      solar_wind: {
        pressure: 3.3,
      },
    },
  },
  heliospheric_model: {
    to_run: true,
    cmes: [],
    Data: {
      solar_wind: '',
    },
    Duration: {
      relaxation: 10.0,
      cme_insertion: 8.0,
      forecast: 4.0,
    },
    Grid: {
      num_radial: 256,
      angular_resolution: 4.0,
      radial: {
        outer_edge: 2,
      },
    },
    cluster: {
      walltime: '0300',
      ppn: 36,
      nodes: 4,
    },
    plotting: {
      meridional_plane: 'Earth',
    },
    VirtualSpacecraft: [
      {
        relative_to: 'Earth',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      {
        relative_to: 'Mercury',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      {
        relative_to: 'Venus',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      {
        relative_to: 'Mars',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      {
        relative_to: 'STA',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      {
        relative_to: 'STB',
        start: 'forecast',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
    ],
  },
};
